var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 196.5 79.5",
    style: {
      enableBackground: "new 0 0 196.5 79.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB3C7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000103961158686121857760000016841259842101945518_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,0h150c12.7,0,23,10.3,23,23v33.3c0,12.7-10.3,23-23,23H23c-12.7,0-23-10.3-23-23V23C0,10.3,10.3,0,23,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,34.7c-5.5-3.8-13.1-2.3-16.9,3.2c-3.8,5.5-2.3,13.1,3.2,16.9c4.1,2.8,9.5,2.8,13.7,0v1.5h6.9v-23H157V34.7z  M150.7,50.7c-3.3-0.2-5.8-3-5.6-6.2c0.2-3.3,3-5.8,6.2-5.6c3.1,0.2,5.6,2.8,5.6,5.9C156.8,48.1,154.1,50.8,150.7,50.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 23,
    width: 7.2,
    height: 33.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,32.6c-2.7-0.2-5.4,1-7.1,3.2v-2.6h-6.9v23h6.9V44.2c-0.2-2.7,1.8-5,4.5-5.2c0.2,0,0.5,0,0.7,0c3,0,4.8,1.8,4.8,5.2 v12.1h6.9V41.6C135.6,36.3,131.3,32.6,125.8,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,34.7c-5.5-3.8-13.1-2.3-16.9,3.2c-3.8,5.5-2.3,13.1,3.2,16.9c4.1,2.8,9.5,2.8,13.7,0v1.5h6.9v-23h-6.9V34.7z  M78,50.7c-3.3-0.2-5.8-3-5.6-6.2c0.2-3.3,3-5.8,6.2-5.6c3.1,0.2,5.6,2.8,5.6,5.9C84.2,48.1,81.4,50.8,78,50.7L78,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,36.3v-3h-7.1v23h7.1V45.5c0-3.6,3.9-5.6,6.7-5.6c0,0,0.1,0,0.1,0v-6.7C106,33.2,103.5,34.3,101.8,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,48.1c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3C175.5,50,173.5,48.1,171.2,48.1 C171.2,48.1,171.2,48.1,171.2,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3,23h-7.5c0,6.1-2.8,11.8-7.7,15.4l-3,2.2l11.5,15.6h9.4L42.5,41.9C47.6,36.9,50.4,30.1,50.3,23z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 23,
    width: 7.5,
    height: 33.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.b279c4c272493da5d27d38d500bea421.svg";
export { ForwardRef as ReactComponent };